<template>
  <div>
    <div class="row">
      <div
        v-if="!visaoSimplificada"
        class="col-xs-6 col-sm-4 col-md-4 col-lg-4"
      >
        <div class="form-group">
          <label for="dataHoraSolicitacao">21 - Data / Hora Solicitação</label>
          <div id="dataHoraSolicitacao" class="input-group">
            <input
              id="dataSolicitacao"
              v-model="guia.solicitacao.data"
              v-mask="'99/99/9999'"
              data-test-id="input-datasolicitacao"
              type="text"
              class="form-control"
              name="dataSolicitacao"
              placeholder="Data da solicitação do procedimento"
            />
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-calendar" />
              </span>
              <span class="dropdown-menu">
                <li>
                  <DatePicker
                    v-model="guia.solicitacao.data"
                    :today-btn="false"
                    :clear-btn="false"
                    :format="'dd/MM/yyyy'"
                    :close-on-selected="true"
                    :date-parser="dataParser"
                    class="date-picker"
                  />
                </li>
              </span>
            </div>
            <span class="input-group-addon">às</span>
            <input
              id="horaSolicitacao"
              v-mask="'99:99'"
              data-test-id="input-horasolicitacao"
              :value="guia.solicitacao.hora"
              type="text"
              class="form-control"
              name="horaSolicitacao"
              placeholder="Hora da solicitação do procedimento"
              @input="atualizaHora(guia.solicitacao, $event.target.value)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-4 col-sm-4 col-md-4 col-lg-4"
      >
        <div
          :class="{ 'has-error': validations.guia.solicitacao.carater.$error }"
          class="form-group"
        >
          <label for="carater"
            >22 - Caráter da solicitação <sup>(1)</sup></label
          >
          <select
            id="carater"
            v-model="guia.solicitacao.carater"
            data-test-id="select-carater"
            name="carater"
            class="form-control"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="carater in caracteres"
              :key="carater.codigo"
              :value="carater.codigo"
              >{{ carater.codigo }} - {{ carater.valor }}
            </option>
          </select>
          <span v-if="validations.guia.solicitacao.carater.$dirty">
            <span
              v-if="!validations.guia.solicitacao.carater.required"
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <div
          :class="{ 'has-error': validations.guia.solicitacao.cid10.$error }"
          class="form-group"
        >
          <label for="cid10">23 - CID10 <sup>(1)</sup></label>
          <BuscarSelecionar
            :lista="cids"
            :selecionado="cid"
            :exibir="['descricaoAbreviada']"
            :minimo="1"
            :exibir-chave="false"
            :classes-input="
              visaoSimplificada ? 'form-control input-sm' : 'form-control'
            "
            @selecionar="selecionarCid"
            @limpar="limparCid"
            @recuperar="recuperarCids"
          />
          <span v-if="validations.guia.solicitacao.cid10.$dirty">
            <span
              v-if="!validations.guia.solicitacao.cid10.required"
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="!validations.guia.solicitacao.cid10.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{ validations.guia.solicitacao.cid10.$params.maxLength.max }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!visaoSimplificada"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
      >
        <div
          :class="{
            'has-error': validations.guia.solicitacao.indicacao.$error,
          }"
          class="form-group"
        >
          <label for="indicacao">24 - Indicação clínica</label>
          <textarea
            v-model="guia.solicitacao.indicacao"
            data-test-id="textarea-indicacao"
            name="indicacao"
            rows="3"
            class="form-control"
            placeholder="Indicação clínica do solicitante"
            @input="validations.guia.solicitacao.indicacao.$touch()"
          />
          <span v-if="validations.guia.solicitacao.indicacao.$dirty">
            <span
              v-if="!validations.guia.solicitacao.indicacao.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{ validations.guia.solicitacao.indicacao.$params.maxLength.max }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          :class="{
            'has-error': validations.guia.solicitacao.procedimentos.$error,
          }"
          class="form-group"
        >
          <span v-if="validations.guia.solicitacao.$dirty">
            <span
              v-if="!validations.guia.solicitacao.procedimentos.maxLength"
              class="help-block"
            >
              Até
              {{
                validations.guia.solicitacao.procedimentos.$params.maxLength.max
              }}
              procedimentos são permitidos.
            </span>
            <span
              v-else-if="!validations.guia.solicitacao.procedimentos.required"
              class="help-block"
            >
              Deve ser adicionado um procedimento.
            </span>
            <span
              v-else-if="validations.guia.solicitacao.procedimentos.$error"
              class="help-block"
            >
              Existem erros no(s) procedimento(s) informado(s), deve ser
              informado pelo menos um procedimento e os Valores devem ser acima
              de 0.
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          v-for="(procedimento, index) in guia.solicitacao.procedimentos"
          :key="procedimento._id"
        >
          <ProcedimentoSolicitado
            :guia="guia"
            :procedimento="procedimento"
            :index="index"
            :validations="validations"
            :visao-simplificada="visaoSimplificada"
            @selecionadoProcedimento="selecionadoProcedimento"
            @limparProcedimento="limparProcedimento"
            @alterouTabela="alterouTabela"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { dominioMixin } from '@/mixins/DominioMixin'
import CidServico from '@/servicos/CidServico'

import ProcedimentoSolicitado from './ProcedimentoSolicitado'

const cidServico = new CidServico()

export default {
  name: 'DadosSolicitacao',
  components: { DatePicker, BuscarSelecionar, ProcedimentoSolicitado },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      cid: {},
      cids: [],
      caracteres: [],
    }
  },
  watch: {
    'guia.solicitacao.cid10'() {
      this.processarCid()
    },
  },
  created() {
    this.recuperarValoresDominio('CaraterSolicitacao').then((res) => {
      this.caracteres = res.valores
    })
  },
  methods: {
    alterouTabela(dados) {
      this.$emit('alterouTabela', dados)
    },
    selecionadoProcedimento(dados) {
      this.$emit('selecionadoProcedimento', dados)
    },
    limparProcedimento(dados) {
      this.$emit('limparProcedimento', dados)
    },
    processarCid() {
      if (this.guia.solicitacao.cid10._id) {
        cidServico
          .recuperarTodos({
            descricaoAbreviada: this.guia.solicitacao.cid10.descricaoAbreviada,
            skip: 0,
            limit: 1,
            ativo: true,
            orderBy: 'descricaoAbreviada',
          })
          .then((result) => {
            if (result.cids.length) {
              this.cid = result.cids[0]
            }
          })
      }
    },
    selecionarCid(cid) {
      this.cid = cid
      this.guia.solicitacao.cid10 = cid
    },
    limparCid() {
      this.cid = {}
      this.guia.solicitacao.cid10 = {}
    },
    recuperarCids(filtro) {
      const data = {
        descricaoAbreviada: filtro.palavra,
        ativo: true,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      cidServico.recuperarTodos(data).then((result) => {
        this.cids = result.cids
      })
    },
    atualizaHora(solicitacao, value) {
      const h = moment(value, 'HH:mm')
      if (value.length === 5 && h.isValid()) {
        solicitacao.hora = value
      }
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
